var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"page-prototype"},[_c('iframe',{attrs:{"src":_vm.constants.LINK_TO_WHITERABBIT,"allow":"autoplay; picture-in-picture","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }